module.exports = __webpack_public_path__ + "img/hr-artillery-wagon-base-shadow-11.20f5c18f.png";